import React, { FC } from 'react';
import { useStyles } from './FeedbackStatus.styles';
import Approved from '@mui/icons-material/MarkChatRead';
import Pending from '@mui/icons-material/AccessTimeOutlined';
import Rejected from '@mui/icons-material/SpeakerNotesOff';
import Review from '@mui/icons-material/Preview';
import EventBusyOutlined from '@mui/icons-material/EventBusyOutlined';
import { EvalFeedbackStatus } from '@modules/EvaluationModule/enums/EvalFeedbackStatus';
import { Popup } from 'reactjs-popup';
import { Typography } from '@mui/material';

interface Props {
  status: EvalFeedbackStatus;
  isClosed?: boolean;
}

export const FeedbackStatus: FC<Props> = ({ status, isClosed = false }) => {
  const styles = useStyles();

  const displayText = isClosed && status === EvalFeedbackStatus.Pending ? 'Feedback not provided' : status;
  const capitalizedText = displayText.charAt(0).toUpperCase() + displayText.slice(1).toLowerCase();

  return (
    <Popup
      className={styles.popup}
      position="top center"
      on={['hover', 'focus', 'click']}
      trigger={
        <div className={styles.iconContainer}>
          {isClosed && status === EvalFeedbackStatus.Pending ? (
            <span className={styles.pendingBtn}>
              <EventBusyOutlined />
            </span>
          ) : [EvalFeedbackStatus.Approved, EvalFeedbackStatus.Submitted].includes(status) ? (
            <span className={styles.approveBtn}>
              <Approved />
            </span>
          ) : status === EvalFeedbackStatus.Rejected ? (
            <span className={styles.rejectBtn}>
              <Rejected />
            </span>
          ) : status === EvalFeedbackStatus.Review ? (
            <span className={styles.reviewBtn}>
              <Review />
            </span>
          ) : (
            <span className={styles.pendingBtn}>
              <Pending />
            </span>
          )}
        </div>
      }
    >
      <Typography variant="body1" className={styles.popupText}>
        {capitalizedText}
      </Typography>
    </Popup>
  );
};
